export default __webpack_public_path__ + "media/images/backgrounds/bg-02-1920x833-a688d337fb0266c782ea29bb542a919d.jpg";